import { NavLink, Outlet, useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { LogOut, FolderOpen, MessageSquare, ExternalLink } from "lucide-react";

export default function AdminLayout() {
    const { admin, logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        navigate("/admin/login", { replace: true });
    };

    const tabClass = ({ isActive }) =>
        `flex items-center gap-3 px-5 py-3 text-sm transition-colors duration-300 border-l-2 ${
            isActive
                ? "border-brass text-cream bg-ink-700/40"
                : "border-transparent text-cream/60 hover:text-cream hover:bg-ink-700/20"
        }`;

    return (
        <div data-testid="admin-layout" className="min-h-screen bg-ink-900 text-cream flex">
            {/* Sidebar */}
            <aside className="w-72 shrink-0 bg-ink-800 border-r border-white/5 flex flex-col">
                <div className="px-6 py-8 border-b border-white/5">
                    <Link to="/" data-testid="admin-sidebar-logo">
                        <img
                            src="/logo-dogaparquet.png"
                            alt="Dogaparquet"
                            className="h-10 w-auto"
                        />
                    </Link>
                    <p className="mt-4 text-[10px] uppercase tracking-widest text-brass">
                        Pannello admin
                    </p>
                </div>

                <nav className="flex-1 py-4">
                    <NavLink
                        to="/admin/portfolio"
                        end
                        className={tabClass}
                        data-testid="admin-nav-portfolio"
                    >
                        <FolderOpen size={16} /> Portfolio
                    </NavLink>
                    <NavLink
                        to="/admin/messages"
                        className={tabClass}
                        data-testid="admin-nav-messages"
                    >
                        <MessageSquare size={16} /> Messaggi
                    </NavLink>
                </nav>

                <div className="border-t border-white/5 p-6 space-y-4">
                    <Link
                        to="/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-2 text-xs uppercase tracking-widest text-cream/50 hover:text-brass transition-colors"
                        data-testid="admin-view-site"
                    >
                        <ExternalLink size={14} /> Vedi sito
                    </Link>
                    <div>
                        <p className="text-[10px] uppercase tracking-widest text-cream/40">
                            Connesso come
                        </p>
                        <p className="text-sm text-cream mt-1 truncate" data-testid="admin-current-email">
                            {admin?.email}
                        </p>
                    </div>
                    <button
                        type="button"
                        onClick={handleLogout}
                        data-testid="admin-logout"
                        className="w-full flex items-center justify-center gap-2 border border-white/10 hover:border-brass hover:text-brass text-cream/70 py-3 text-xs uppercase tracking-widest transition-colors"
                    >
                        <LogOut size={14} /> Esci
                    </button>
                </div>
            </aside>

            {/* Main */}
            <section className="flex-1 overflow-x-hidden">
                <Outlet />
            </section>
        </div>
    );
}
